import { gql } from '@apollo/client'

export function GET_PERSONAL_DOCUMENTS(userName) {
  return gql`
    query {
      fetchPersonalDocuments(userName: "${userName}") {
        id
         clientId
         userName
         aadharDocument{
            url
            name
            originalName
            size
            storage
            type
            data{
                baseUrl
                form
                id
                project
                version
            }
         }
         panDocument{
            url
            name
            originalName
            size
            storage
            type
          data{
            baseUrl
            form
            id
            project
            version
          }
         }
         otherDocuments{
            url
            name
            originalName
            size
            storage
            type
            data{
              baseUrl
              form
              id
              project
              version
            }
         }
      }
    }
  `
}

export const UPLOAD_PERSONAL_DOCUMENT = gql`
  mutation ($documents: [Upload!], $documentType: String!, $userName: String!) {
    uploadPersonalDocument(
      documents: $documents
      documentType: $documentType
      userName: $userName
    ) {
      success
      message
    }
  }
`
export const DELETE_DOCUMENT = gql`
  mutation DeletePersonalDocument(
    $documentId: String!
    $userName: String!
    $documentType: String!
  ) {
    deletePersonalDocument(
      documentId: $documentId
      userName: $userName
      documentType: $documentType
    ) {
      message
      success
    }
  }
`
